import { useState } from 'react';

export type DynamicImageProps = {
  src: string;
  alt: string;
  testId: string;
  className?: string;
  loading?: 'lazy' | 'eager';
};

export const DynamicImage: React.FC<DynamicImageProps> = ({
  src,
  alt,
  testId,
  className,
  loading = 'eager',
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <img
      data-test-id={`${testId}-container`}
      src={src}
      className={className}
      loading={loading}
      onLoad={() => setIsLoaded(true)}
      onError={() => setIsLoaded(true)}
      alt={alt}
      style={{
        opacity: isLoaded ? 1 : 0,
        transition: 'opacity 0.3s ease-out',
      }}
    />
  );
};
